<template>
  <v-container class="px-6 px-sm-12">
    <PageHeader :header-text="'Tanks'" :header-icon="'mdi-car-coolant-level'" />

    <div v-if="tanksLoading">
      <v-progress-circular color="primary" indeterminate> </v-progress-circular>
    </div>

    <div v-else-if="!tanksLoading && tanksGroupedByVessel">
      <TankStatusGroupCard
        v-for="(value, key) in tanksGroupedByVessel"
        :key="key"
        class="mb-6 elevation-0"
        :groupTitle="key"
        groupIcon="mdi-ferry"
        :tanks="value"
        :onUpdateTankStatusClicked="openUpdateStatusDialog"
        color="transparent"
      />
    </div>

    <div v-else>
      <v-row justify="center">
        <InfoAlert message="No tanks found for site" />
      </v-row>
    </div>

    <!-- Update Status Dialog -->
    <v-dialog v-model="updateTankStatusDialog" max-width="950px">
      <v-card>
        <TankStatusForm
          :status="tankStatus"
          :onSubmitClick="submitTankStatus"
          :onCloseClick="closeUpdateStatusDialog"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TankStatusMixin from '../mixins/TankStatusMixin';
import TankStatusForm from '../components/tanks/TankStatusForm.vue';
import PageHeader from '../components/ui/PageHeader.vue';
import TankStatusGroupCard from '../components/tanks/TankStatusGroupCard.vue';
import InfoAlert from '../components/ui/InfoAlert.vue';

export default {
  name: 'Tanks',
  components: {
    PageHeader, TankStatusGroupCard, TankStatusForm, InfoAlert,
  },
  mixins: [TankStatusMixin],
  data() {
    return {
      tanksLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      getTankStatusesByGroup: 'tanksStore/getTankStatusesByGroup',
      getActiveSiteId: 'userStore/getActiveSiteId',
      getSyncedAndUnsyncedTankStatuses: 'tanksStore/getSyncedAndUnsyncedTankStatuses',
      getSyncedAndUnsyncedTankStatusesByGroup: 'tanksStore/getSyncedAndUnsyncedTankStatusesByGroup',
    }),
    activeSiteId() {
      return this.getActiveSiteId;
    },
    tanksGroupedByVessel() {
      return this.getSyncedAndUnsyncedTankStatusesByGroup('vesselName');
    },
  },
  watch: {
    activeSiteId(newVal) {
      this.loadTankData();
    },
  },
  created() {
    this.loadTankData();
  },
  methods: {
    loadTankData() {
      this.tanksLoading = true;
      this.$store.dispatch('tanksStore/loadTankStatuses', this.activeSiteId)
        .then(this.$store.dispatch('dataSyncStore/loadTankStatusesToBeSynced'))
        .finally(() => { this.tanksLoading = false; });
    },
  },
};
</script>

<style>
</style>
